import { useAuth } from './AuthProvider.js';
import { Button } from '../../components/ui/Button.js';

/** Shown after POST /api/auth/session returns DOMAIN_NOT_ALLOWED — see docs/PLAN.md §2.2. */
export function DomainRejectedScreen() {
  const { rejectedDomainMessage, signInWithGoogle } = useAuth();

  return (
    <div className="flex min-h-dvh items-center justify-center bg-bg p-4">
      <div className="flex w-full max-w-md flex-col items-center gap-4 rounded-card border border-border bg-surface p-6 text-center shadow-sm sm:p-8">
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[color-mix(in_srgb,var(--danger)_15%,transparent)]">
          <svg
            width="22"
            height="22"
            viewBox="0 0 16 16"
            fill="none"
            stroke="var(--danger)"
            strokeWidth="1.6"
          >
            <rect x="2" y="6.8" width="12" height="7" rx="1.8" />
            <path d="M5 6.8V5a3 3 0 0 1 6 0v1.8" />
          </svg>
        </div>
        <h1 className="text-lg font-semibold">Your organisation isn't enabled yet</h1>
        <p className="text-sm text-muted wrap-break-word">
          {rejectedDomainMessage ?? 'Your email domain is not on the allowlist for this app.'}
        </p>
        <p className="text-xs text-muted">
          Ask your org owner to add your domain, or run{' '}
          <code className="rounded bg-surface-2 px-1 py-0.5 font-mono">pulse allowlist:add</code>.
        </p>
        <Button className="mt-2 h-10 sm:h-8" onClick={() => void signInWithGoogle()}>
          Try again
        </Button>
      </div>
    </div>
  );
}
